import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    draftGroupMessages: [],
};

export const draftMessages = createSlice({
    name:'draftMessages',
    initialState,
    reducers:{
        updateDraftMessage: (state, action) => {
            const newItem = action.payload;
            const index = state.draftGroupMessages.findIndex(item => item.id === newItem.id);

            if (index !== -1) {
                state.draftGroupMessages[index] = newItem;
            } else {
                state.draftGroupMessages.push(newItem);
            }
        },
        removeDraftById: (state, action) => {
        const idToRemove = action.payload;
        state.draftGroupMessages = state.draftGroupMessages.filter(item => item.id !== idToRemove); // Remove by id
        },
    }
})

export const{updateDraftMessage,removeDraftById} = draftMessages.actions

export default draftMessages.reducer